import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fdb958de"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 0,
  class: "folder-item-author"
}
const _hoisted_3 = {
  key: 1,
  class: "item-author-info"
}
const _hoisted_4 = {
  key: 0,
  class: "name"
}
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_question_pop_up = _resolveComponent("app-question-pop-up")!
  const _component_folder_settings_pop_up = _resolveComponent("folder-settings-pop-up")!
  const _component_drive_folder_settings_pop_up = _resolveComponent("drive-folder-settings-pop-up")!
  const _component_move_to_pop_up = _resolveComponent("move-to-pop-up")!
  const _component_share_pop_up = _resolveComponent("share-pop-up")!
  const _component_app_rename_folder = _resolveComponent("app-rename-folder")!
  const _component_folder_info_pop_up = _resolveComponent("folder-info-pop-up")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ 'folder-item-wrapper': _ctx.columnView })
  }, [
    _createElementVNode("div", {
      class: "folder-item",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openFolder && _ctx.openFolder(...args)))
    }, [
      _createElementVNode("img", {
        src: _ctx.folderImage,
        alt: "folder"
      }, null, 8, _hoisted_1),
      (!!_ctx.folder.share && !_ctx.isNetwork)
        ? (_openBlock(), _createElementBlock("i", {
            key: 0,
            class: _normalizeClass(["icon icon-users", { 'folder-item-shared': _ctx.columnView }])
          }, null, 2))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.hideAuthor)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (!_ctx.hideTitle)
            ? (_openBlock(), _createElementBlock("p", {
                key: 0,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openFolder && _ctx.openFolder(...args))),
                class: "folder-name"
              }, _toDisplayString(_ctx.folder.name), 1))
            : _createCommentVNode("", true),
          (_ctx.isNetwork)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_ctx.columnView && !_ctx.mainStore.isMobile)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.authorName), 1))
                  : _createCommentVNode("", true),
                (_ctx.photoUrl)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      class: "photo",
                      src: _ctx.photoUrl
                    }, null, 8, _hoisted_5))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.showDots)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.popUpSwitcher = _ctx.FOLDER_SETTINGS_POP_UP_SWITCHER.SETTINGS; _ctx.getPosition($event)}),
                class: "icon icon-dots folder-item-option"
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.columnView && _ctx.showArrow)
      ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openFolder && _ctx.openFolder(...args))),
          class: "icon icon-back"
        }))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_Teleport, { to: "#popup" }, [
      (_ctx.popUpSwitcher === _ctx.FOLDER_SETTINGS_POP_UP_SWITCHER.DELETE)
        ? (_openBlock(), _createBlock(_component_app_question_pop_up, {
            key: 0,
            onDelete: _ctx.deleteFolder,
            onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.popUpSwitcher = null))
          }, null, 8, ["onDelete"]))
        : _createCommentVNode("", true),
      (_ctx.popUpSwitcher === _ctx.FOLDER_SETTINGS_POP_UP_SWITCHER.SETTINGS && _ctx.mainStore.isMobile)
        ? (_openBlock(), _createBlock(_component_folder_settings_pop_up, {
            key: 1,
            folder: _ctx.folder,
            disableMove: _ctx.disableMove,
            disableShare: _ctx.disableShare,
            onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.popUpSwitcher = null)),
            onDeleteFolder: _cache[6] || (_cache[6] = ($event: any) => (_ctx.popUpSwitcher = _ctx.FOLDER_SETTINGS_POP_UP_SWITCHER.DELETE)),
            onOpenMovePopUp: _cache[7] || (_cache[7] = ($event: any) => (_ctx.popUpSwitcher = _ctx.FOLDER_SETTINGS_POP_UP_SWITCHER.MOVE)),
            onRenameFolder: _cache[8] || (_cache[8] = ($event: any) => (_ctx.popUpSwitcher = _ctx.FOLDER_SETTINGS_POP_UP_SWITCHER.RENAME)),
            onShareFolder: _cache[9] || (_cache[9] = ($event: any) => (_ctx.popUpSwitcher = _ctx.FOLDER_SETTINGS_POP_UP_SWITCHER.SHARE)),
            onOpenInfoPopUp: _cache[10] || (_cache[10] = ($event: any) => (_ctx.popUpSwitcher = _ctx.FOLDER_SETTINGS_POP_UP_SWITCHER.INFO)),
            onSaveFolderAsCopy: _ctx.saveFolderAsCopy
          }, null, 8, ["folder", "disableMove", "disableShare", "onSaveFolderAsCopy"]))
        : _createCommentVNode("", true),
      (_ctx.popUpSwitcher === _ctx.FOLDER_SETTINGS_POP_UP_SWITCHER.SETTINGS && !_ctx.mainStore.isMobile)
        ? (_openBlock(), _createBlock(_component_drive_folder_settings_pop_up, {
            key: 2,
            folder: _ctx.folder,
            disableMove: _ctx.disableMove,
            disableShare: _ctx.disableShare,
            positionData: _ctx.positionData,
            onClose: _cache[11] || (_cache[11] = ($event: any) => (_ctx.popUpSwitcher = null)),
            onDeleteFolder: _cache[12] || (_cache[12] = ($event: any) => (_ctx.popUpSwitcher = _ctx.FOLDER_SETTINGS_POP_UP_SWITCHER.DELETE)),
            onOpenMovePopUp: _cache[13] || (_cache[13] = ($event: any) => (_ctx.popUpSwitcher = _ctx.FOLDER_SETTINGS_POP_UP_SWITCHER.MOVE)),
            onRenameFolder: _cache[14] || (_cache[14] = ($event: any) => (_ctx.popUpSwitcher = _ctx.FOLDER_SETTINGS_POP_UP_SWITCHER.RENAME)),
            onShareFolder: _cache[15] || (_cache[15] = ($event: any) => (_ctx.popUpSwitcher = _ctx.FOLDER_SETTINGS_POP_UP_SWITCHER.SHARE)),
            onOpenInfoPopUp: _cache[16] || (_cache[16] = ($event: any) => (_ctx.popUpSwitcher = _ctx.FOLDER_SETTINGS_POP_UP_SWITCHER.INFO)),
            onSaveFolderAsCopy: _ctx.saveFolderAsCopy
          }, null, 8, ["folder", "disableMove", "disableShare", "positionData", "onSaveFolderAsCopy"]))
        : _createCommentVNode("", true),
      (_ctx.popUpSwitcher === _ctx.FOLDER_SETTINGS_POP_UP_SWITCHER.MOVE)
        ? (_openBlock(), _createBlock(_component_move_to_pop_up, {
            key: 3,
            item: _ctx.folder,
            itemType: _ctx.SHARE_TYPES.FOLDER,
            onClose: _cache[17] || (_cache[17] = ($event: any) => (_ctx.popUpSwitcher = null))
          }, null, 8, ["item", "itemType"]))
        : _createCommentVNode("", true),
      (_ctx.popUpSwitcher === _ctx.FOLDER_SETTINGS_POP_UP_SWITCHER.SHARE)
        ? (_openBlock(), _createBlock(_component_share_pop_up, {
            key: 4,
            item: _ctx.folder,
            "item-type": _ctx.SHARE_TYPES.FOLDER,
            onHide: _cache[18] || (_cache[18] = ($event: any) => (_ctx.popUpSwitcher = null)),
            onSetItemShared: _ctx.setFolderShared,
            onSetSharedLabels: _ctx.setFolderSharedLabels,
            preloadFolderSharedInfo: ""
          }, null, 8, ["item", "item-type", "onSetItemShared", "onSetSharedLabels"]))
        : _createCommentVNode("", true),
      (_ctx.popUpSwitcher === _ctx.FOLDER_SETTINGS_POP_UP_SWITCHER.RENAME)
        ? (_openBlock(), _createBlock(_component_app_rename_folder, {
            key: 5,
            folder: _ctx.folder,
            "mount-error-info": _ctx.renameMountErrorInfo,
            onClose: _cache[19] || (_cache[19] = ($event: any) => (_ctx.popUpSwitcher = null)),
            onOpen: _ctx.openRenamePopUp,
            onClearMountErrorInfo: _cache[20] || (_cache[20] = ($event: any) => (_ctx.renameMountErrorInfo = undefined))
          }, null, 8, ["folder", "mount-error-info", "onOpen"]))
        : _createCommentVNode("", true),
      (_ctx.popUpSwitcher === _ctx.FOLDER_SETTINGS_POP_UP_SWITCHER.INFO)
        ? (_openBlock(), _createBlock(_component_folder_info_pop_up, {
            key: 6,
            folder: _ctx.folder,
            onClose: _cache[21] || (_cache[21] = ($event: any) => (_ctx.popUpSwitcher = null))
          }, null, 8, ["folder"]))
        : _createCommentVNode("", true)
    ]))
  ], 2))
}